import React from 'react'

function HeroSection() {
  return (
    <div>
        <img src="https://static.vecteezy.com/system/resources/previews/004/299/835/original/online-shopping-on-phone-buy-sell-business-digital-web-banner-application-money-advertising-payment-ecommerce-illustration-search-free-vector.jpg" alt="" />
    </div>
  )
}

export default HeroSection